<script setup lang="ts">

import AccordionBody from '../components/accordion/AccordionBody.vue';
import AccordionTrigger from '../components/accordion/AccordionTrigger.vue';
import AccordionComponent from '../components/accordion/AccordionComponent.vue';
import AccordionContent from '../components/accordion/AccordionContent.vue';
import { Hint } from '../types';
import { ref } from 'vue';

const hints = ref<Hint[]>([
  {
    title: "Не помню логин и пароль от АЭБ Онлайн. Как войти?",
    heading: "Если у вас есть дебетовая или кредитная карта Алмазэргиэнбанка, вы можете восстановить доступ самостоятельно:",
    content: [
      {
        type: "list",
        listContent: [
          "На стартовом экране выберите «Вход по логину и паролю»",
          "На экране ввода логина и пароля нажмите на «Вход по номеру карты или счета»",
          "На экране входа введите номер карты, номер телефона и данные паспорта при необходимости",
          "Подтвердите номер телефона СМС кодом",
          "На появившемся экране введите новые логин и пароль",
          "Задайте код доступа в приложение. Повторите код доступа"
        ]
      },
      {
        type: "text",
        textContent: "Если у вас нет карты Алмазэргиэнбанка, пожалуйста, обратитесь в колл-центр по номеру 8 800 100-34-22"
      },
      {
        type: "text",
        textContent: "Также вы всегда можете восстановить доступ в любом отделении банка."
      }
    ]
  },
  {
    title: "Как получить справку или выписку по счету",
    content: [
      {
        type: "list",
        listContent: [
          "Перейдите в раздел «Еще»",
          "Нажмите на «Справки и выписки»",
          "Выберите нужный вам вид справок",
          "Выберите счет для получения справки",
          "Укажите электронный адрес или скачайте справку в приложении"
        ]
      }
    ]
  },
  {
    title: "Как сделать перевод по номеру телефона через СБП",
    content: [
      {
        type: "list",
        listContent: [
          "Войдите в раздел «Оплатить» через нижнее меню навигации или через экран карты",
          "В поле «Все переводы по телефону» введите номер телефона получателя",
          "Выберите банк получателя",
          "Введите сумму перевода",
          "При необходимости введите нужный текст в поле «Сообщение»",
          "Нажмите кнопку «Продолжить»",
          "Убедитесь, что получатель, банк и сумма указаны верно",
          "Нажмите «Перевести» для совершения перевода"
        ]
      }
    ]
  },
  {
    title: "Как оплатить услуги ЖКХ в приложении",
    content: [
      {
        type: "list",
        listContent: [
          "Перейдите в раздел «Оплатить» через нижнее меню навигации или через экран карты",
          "В разделе «Оплата услуг» нажмите на кнопку «ЖКХ»",
          "В списке или через поиск выберите нужную управляющую компанию",
          "Введите лицевой счет, сумму оплаты и нажмите «Продолжить»",
          "Чтобы убедиться, что лицевой счет введен верно, проверьте адрес в поле «Информация»",
          "Нажмите «Оплатить»",
        ]
      }
    ]
  },
])
</script>

<template>
  <div class="hints screen screen-container">
    <h2>Полезные подсказки</h2>

    <div class="hints__content">
      <AccordionComponent 
        v-for="hint in hints" :key="hint.title" 
        class="accordion-wrapper"
      >
        <AccordionTrigger class-name="accordion-trigger" :title="hint.title" />
        <AccordionBody>
          <br />
          <div 
            v-if="hint.heading"
            class="hint__heading"
          >{{ hint.heading }}</div>
          <AccordionContent :content="hint.content"/>
        </AccordionBody>
      </AccordionComponent>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.hints {
  &__content {
    gap: 20px;
    width: 100%;
    display: flex;
    margin-top: 60px;
    flex-direction: column;
  }
}

.hint {
  &__heading {
    margin-bottom: 20px;
  }
}
</style>
